import {actionIds, BaseAction} from "../common";

const getTestresultsAction: () =>
    BaseAction = () => ({
    type: actionIds.GET_TESTRESULTS,
    payload: {},
});

export default getTestresultsAction;
